import { render, staticRenderFns } from "./ImportEmailsPlanReleaseLog.vue?vue&type=template&id=6dd63133&scoped=true&"
import script from "./ImportEmailsPlanReleaseLog.vue?vue&type=script&lang=js&"
export * from "./ImportEmailsPlanReleaseLog.vue?vue&type=script&lang=js&"
import style0 from "./ImportEmailsPlanReleaseLog.vue?vue&type=style&index=0&id=6dd63133&lang=scss&scoped=true&"
import style1 from "./ImportEmailsPlanReleaseLog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd63133",
  null
  
)

export default component.exports